import { useLazyQuery, useMutation } from "@apollo/client";
import { listCountries } from "GraphQL/queries/metaData";
import {
  getLoggedInUser,
  getLoggedInUserCompany,
  metaData,
} from "GraphQL/queries/profile";
import { setCountries } from "Recoil/CompanySetup/selector";
import {
  CompanyState,
  loggedInUserState,
  metaDataState,
} from "Recoil/LoggedInUserDetail/atom";
import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { FETCH_POLICY } from "src/constants";
import { GETUSER_COMPANY } from "../../constants/literalConstant";
import { get } from "lodash";
import { logOutUser } from "GraphQL/mutation/visionBoardMutations";
import { ONBOARDING } from "src/constants/routeConstants";
import { useHistory } from "react-router";

export const useLayout = () => {
  const history = useHistory();
  const addCountries = useSetRecoilState(setCountries);
  const setMetaDataDetails = useSetRecoilState(metaDataState);
  const [userDetails, setUserDetails] = useState();
  const setLoggedInUserState = useSetRecoilState(loggedInUserState);
  const setCompanyDetails = useSetRecoilState(CompanyState);

  const [logOutUserDetail, { loading: logOutLoading }] =
    useMutation(logOutUser);
  const [getUserDetail] = useLazyQuery(getLoggedInUser, {
    ssr: false,
    nextFetchPolicy: FETCH_POLICY.cacheOnly,
    onCompleted: (data) => {
      setLoggedInUserState({
        ...userDetails,
        ...get(data, "getUser", {}),
      });
      setUserDetails({
        ...userDetails,
        ...get(data, "getUser", {}),
      });
      if (get(data, "getUser.onboarding", "") != "Completed") {
        history.push({
          pathname: `${ONBOARDING}`,
          state: { login: true },
        });
      }
    },
  });

  const [getUserCompany] = useLazyQuery(getLoggedInUserCompany, {
    ssr: false,
    nextFetchPolicy: FETCH_POLICY.cacheOnly,
    onCompleted: (data) => {
      setCompanyDetails(get(data, GETUSER_COMPANY, {}));
      setLoggedInUserState({
        ...userDetails,
        company: get(data, GETUSER_COMPANY, {}),
      });
      setUserDetails({
        ...userDetails,
        company: get(data, GETUSER_COMPANY, {}),
      });
    },
  });
  const [metaDataDetailValues] = useLazyQuery(metaData, {
    onCompleted: (data) => {
      setMetaDataDetails(get(data, "listMetaData.items", []));
    },
  });

  const [getCountriesList] = useLazyQuery(listCountries, {
    onCompleted: (data) => {
      addCountries(data);
    },
  });
  return {
    getUserDetail,
    getUserCompany,
    metaDataDetailValues,
    getCountriesList,
    logOutUserDetail,
    logOutLoading,
  };
};
